import { Container, Row, Col } from 'react-bootstrap';
import PageHero from '../components/PageHero';

export default function InfoCommunityMeetings() {
  return (
    <div className="page-content">
      <PageHero
        eyebrow="Conference info"
        title="Community Meetings"
        intro="Working Group Meetings are open to all conference participants and provide an opportunity to engage with the aerosol research community."
      />

      <main className="info-page pt-5 pb-5">
        <Container className='pt-5'>
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className='h1'>Working Group Meetings</h2>

                <p>
                  <span className="text-marker">Every conference participant</span> is warmly invited to attend the Working Group (WG) Meetings.
                </p>

                <p>
                  This year, each WG Meeting will begin with a scientific keynote lecture on a topic of current
                  interest within the respective field, moderated by the WG Chair. Following a Q&amp;A session,
                  participants will have the opportunity to discuss the scientific programme of the current and future
                  European Aerosol Conferences, emerging research directions, and other activities within the Working Group.
                </p>

                <p>
                  WG Meetings will be held <span className="text-marker">from Tuesday through Thursday.</span> Please consult the conference programme for
                  exact times and locations.
                </p>

                <p>
                  Whether you are interested in volunteering as an abstract reviewer, proposing a special session for
                  future EAC conferences, contributing to Working Group activities, or simply keeping up with developments
                  in your research field, WG Meetings are the place to be. We encourage you to bring your colleagues,
                  including young researchers and students, and join the discussion.
                </p>
              </section>
              <section className="info-section">
                <h2>What are Working Groups and which meeting should you attend?</h2>

                <p>
                  The scientific programme of the European Aerosol Conference is built around the five Working Groups of
                  the <a href="https://www.info.gaef.de/eaa#dataItem-ky0dff7e" target='_blank' rel="noreferrer">European Aerosol Assembly</a>, representing the major branches of aerosol research:
                </p>

                <ul className="info-list mb-3">
                  <li>
                    
                  <a href="https://www.info.gaef.de/working-group-1" target='_blank' rel="noreferrer">WG1 – Aerosol Technology</a>
                  </li>
                  <li>
                    
                  <a href="https://www.info.gaef.de/working-group-2" target='_blank' rel="noreferrer">WG2 – Atmospheric Aerosol Studies</a>
                  </li>
                  <li>
                    
                  <a href="https://www.info.gaef.de/working-group-3" target='_blank' rel="noreferrer">WG3 – Aerosol Measurement Techniques</a>
                  </li>
                  <li>
                    
                  <a href="https://www.info.gaef.de/working-group-4" target='_blank' rel="noreferrer">WG4 – Aerosols and Health</a>
                  </li>
                  <li>
                    
                  <a href="https://www.info.gaef.de/working-group-5" target='_blank' rel="noreferrer">WG5 – Basic Aerosol Processes</a>
                  </li>
                </ul>

                <p>
                  Each Working Group is led by a WG Chair and several WG Co-chairs who represent different research
                  directions within the field. However, the Working Groups are <span className="text-marker">community-driven</span> and open to all members
                  of the aerosol research community. Researchers are encouraged to contribute to one or more Working
                  Groups according to their interests and expertise, and help shape the future of aerosol research in
                  Europe and beyond.
                </p>

                <p>
                  WG Meetings are a long-standing <span className="text-marker">tradition</span> of the European Aerosol Conference. They are the backbone of
                  the scientific programme of each EAC and provide a unique opportunity to engage with the community,
                  exchange ideas, and influence future scientific activities within your field.
                </p>
              </section>
            </Col>
          </Row>
        </Container>
      </main>
    </div>
  );
}